let alert_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'alerts', name: 'alerts.list', component: () => import('./pages/Index.vue') },
      { path: 'alerts/create', name: 'alerts.create', component: () => import('./pages/Create.vue') },
      { path: 'alerts/:id/edit', name: 'alerts.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default alert_routes;
